export default "/images/63353a7eefb768e4b312756c6eb75947.avif";